<template>
  <div class="results-actions-cell">
    <Button class="btn icon square outline-white xs primary-hover" icon="bi-search" @click="onView"></Button>
    <VDropdown placement="left" :distance="10">
      <button class="btn icon square outline-white xs primary-hover">
        <i class="bi bi-cloud-download"></i>
      </button>
      <template #popper>
        <div class="action" v-close-popper @click="exportPdf('organisation-simplified-report')">
          <span>{{ $t("app.campaign.newPage.slidingPanel.options.report.simplified") }}</span>
        </div>
        <div class="action" v-close-popper @click="exportPdf('organisation-full-report')">
          <span>{{ $t("app.campaign.newPage.slidingPanel.options.report.complete") }}</span>
        </div>
      </template>
    </VDropdown>
  </div>
</template>

<script setup lang="ts">
import { useCampaign } from '@/queries/campaigns.query';
import { ResultRow } from '@/types/results';
import type { ICellRendererParams } from 'ag-grid-community';

const appStore = useAppStore();

const props = defineProps<{
  params: ICellRendererParams<ResultRow>, // injected by AG Grid, contains `data`, `api`, etc.
}>();

const pdfIsLoading = ref(false);

function onView() {
  (props.params as any).onView(props.params.data);
}


async function exportPdf(pdfType: 'organisation-simplified-report' | 'organisation-full-report') {
  pdfIsLoading.value = true;
  try {
    const pdf = await appStore.exportPdf(pdfType, props?.params?.data?.id);
    const fileURL = URL.createObjectURL(new Blob([pdf], { type: 'application/pdf' }));
    window.open(fileURL, '_blank');
  } finally {
    pdfIsLoading.value = false;
  }
}

</script>

<style lang="scss">

.results-actions-cell {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  gap: 4px;
  height: 100%;
}
</style>